import { styled } from '@mui/material/styles'
import { ID } from 'api'
import { useEffect, useState } from 'react'
import { colors } from 'styles/theme'
import CopyToClipboard from '../CopyToClipBoard'

interface Props {
  id: ID
  copy?: boolean
}

export default function EntityID(props: Props) {
  const [showCheckMark, setShowCheckMark] = useState<boolean>(false)

  useEffect(() => {
    let id = null
    if (showCheckMark) {
      id = setTimeout(() => setShowCheckMark(false), 2000)
    }
    return () => clearTimeout(id)
  }, [showCheckMark])

  return (
    <Flex>
      <Text>#{props.id}</Text>
      {props.copy && <CopyToClipboard value={props.id} />}
    </Flex>
  )
}

const Flex = styled('div')`
  display: flex;
  align-items: center;
  color: ${colors.gray[700]};
`

const Text = styled('div')`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25;
`
